<template>
  <a-collapse
    v-model:activeKey="activeKey"
    expand-icon-position="right"
    :bordered="false"
  >
    <a-collapse-panel key="performance">
      <performance-content
        class="performance-content"
        v-bind="$attrs"
      />
      <template #header>
        <a-space :style="{ marginLeft: '24px' }">
          <IconFont
            type="iconfazhan"
            :style="{ fontSize: '18px' }"
          />
          <span :style="{ fontWeight: 'bold' }">
            {{ $t('okr.list.performanceTarget') }}
          </span>
        </a-space>
      </template>
    </a-collapse-panel>
  </a-collapse>
</template>
<script>
import { ref } from 'vue'
import PerformanceContent from '../../PerformanceContent.vue'
export default {
  components: { PerformanceContent },
  setup () {
    const activeKey = ref(['performance'])
    return {
      activeKey
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  padding: 0 10px 0 36px;
}

:deep(.ant-collapse-content) > .ant-collapse-content-box {
  padding: 4px 16px 16px 16px !important;
}

:deep(.ant-collapse-header) {
  padding: 12px 2px !important;
  display: flex;
  align-items: center;

  .ant-collapse-arrow {
    margin-left: 8px;
    position: static !important;
    order: 2;
    transform: none !important;
  }
}

.performance-content {
  padding: 0 16px 0 36px;
}
</style>
